export const organizationNavigation: any[] = [
  {
    id: 'resources',
    title: 'resources',
    subtitle: '',
    type: 'group',
    icon: 'heroicons_outline:home',
    classes: {
      wrapper: 'hidden',
    },
    children: [
      {
        id: 'dashboard',
        title: 'Dashboard',
        titlePt: 'dashboard',
        titleEn: 'dashboard',
        titleEs: 'tablero',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/dashboard',
      },
      {
        id: 'finance',
        title: 'Finance',
        titlePt: 'financeiro',
        titleEn: 'finance',
        titleEs: 'finanzas',
        type: 'basic',
        icon: 'mat_outline:payments',
        link: '/dashboard/finance',
      },
      {
        id: 'records',
        title: 'Records',
        titlePt: 'cadastros',
        titleEn: 'records',
        titleEs: 'registros',
        type: 'collapsable',
        icon: 'heroicons_outline:collection',
        children: [
          {
            id: 'records.users',
            title: 'Users',
            titlePt: 'usuários',
            titleEn: 'users',
            titleEs: 'usuarios',
            type: 'basic',
            icon: 'heroicons_outline:user',
            link: '/records/users',
          },
          {
            id: 'records.products',
            title: 'Products',
            titlePt: 'produtos',
            titleEn: 'products',
            titleEs: 'productos',
            type: 'basic',
            icon: 'heroicons_outline:shopping-cart',
            link: '/products',
          },
        ],
      },
      {
        id: 'settings',
        title: 'Settings',
        titlePt: 'configurações',
        titleEn: 'settings',
        titleEs: 'configuración',
        type: 'basic',
        icon: 'heroicons_outline:adjustments',
        link: '/cfg',
      },
    ],
  },
];
